import DateInput from '@/common/components/base/input/dateInput/DateInput';
import RadioGroup from '@/common/components/base/input/radioGroup/RadioGroup';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import {
  ONLY_NUMBERS_RULE,
  PERSIAN_LATTER_RULE,
} from '@/common/components/base/input/textInput/textInput.rules';
import { NATIONAL_CODE_RULE } from '@/common/utils/rules/nationalCode.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import { validateNotFutureDate } from '@/modules/adjusterReportModules/IncidentDetails/utils/incidentDetails.util';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const InitialRealOwnerForm = () => {
  return (
    <>
      <RadioGroup
        title="جنسیت راننده"
        name="personal_information.gender"
        options={[
          { label: 'آقا', value: 'male' },
          { label: 'خانم', value: 'female' },
        ]}
        renderRadioButton={(Component) => <Box>{Component}</Box>}
        className={css({
          paddingBottom: '24px',
          gap: '2rem',
        })}
      />
      <TextInput
        rules={{ required: requiredText, ...PERSIAN_LATTER_RULE }}
        name="personal_information.first_name"
        label="نام"
      />
      <TextInput
        rules={{ required: requiredText, ...PERSIAN_LATTER_RULE }}
        name="personal_information.last_name"
        label="نام خانوادگی"
        key={'last_name'}
      />
      <DateInput
        buttonText="ثبت"
        modalLabel="تاریخ تولد"
        rules={{ validate: validateNotFutureDate }}
        name="personal_information.birthdate"
        label="تاریخ تولد"
        key={'birthdate'}
      />
      <TextInput
        rules={{
          required: requiredText,
          ...ONLY_NUMBERS_RULE,
          ...NATIONAL_CODE_RULE,
        }}
        name="personal_information.national_code"
        label="کد ملی"
        noCharInput
        key={'national_code'}
        max={10}
      />
      <TextInput
        name="personal_information.father_name"
        label="نام پدر"
        optionalLabel
        rules={{ ...PERSIAN_LATTER_RULE }}
      />
      <TextInput
        name="personal_information.identity_number"
        label="شماره شناسنامه"
        rules={{
          pattern: {
            value: /^[0-9]*$/,
            message: 'شماره شناسنامه نامعتبر است',
          },
        }}
        optionalLabel
        noCharInput
        key={'identity_number'}
      />
      <TextInput
        name="personal_information.identity_issue_location"
        label="محل صدور شناسنامه"
        optionalLabel
        key={'identity_issue_location'}
      />
    </>
  );
};
export default InitialRealOwnerForm;
